<template>
  <div class="summary-detail" v-loading="loading">
    <WelcomeBanner :title="summary.title || '工作总结详情'" :subtitle="summary.summary_date || ''">
      <div slot="right">
        <el-button type="text" icon="el-icon-arrow-left" size="small" @click="goBack">返回</el-button>
        <el-tag :type="getTypeTagType(summary.summary_type)" effect="dark" size="medium">
          {{ summary.summary_type_name || getTypeName(summary.summary_type) }}
        </el-tag>
      </div>
    </WelcomeBanner>

    <BaseCard>
      <!-- 基本信息卡片 -->
      <el-card class="info-card" v-if="!loading">
      <div slot="header" class="card-header">
        <span><i class="el-icon-info"></i> 基本信息</span>
      </div>
      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">总结标题：</span>
          <span class="info-value">{{ summary.title || summary.summary_type_name + ' - ' + summary.summary_date }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">总结日期：</span>
          <span class="info-value">{{ summary.summary_date || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">机器人员工：</span>
          <span class="info-value">
            <el-avatar size="small" :style="{ backgroundColor: getAvatarColor(summary.robot_name) }">
              {{ getRobotInitial(summary.robot_name) }}
            </el-avatar>
            {{ summary.robot_name || summary.robot_id || '-' }}
          </span>
        </div>
        <div class="info-item">
          <span class="info-label">创建时间：</span>
          <span class="info-value">{{ formatTime(summary.create_time) }}</span>
        </div>
        <div class="info-item" v-if="summary.update_time">
          <span class="info-label">更新时间：</span>
          <span class="info-value">{{ formatTime(summary.update_time) }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">内容字数：</span>
          <span class="info-value">{{ summary.content ? summary.content.length : 0 }} 字</span>
        </div>
      </div>
      </el-card>

      <!-- 总结内容卡片 -->
      <el-card class="content-card">
      <div slot="header" class="card-header">
        <span><i class="el-icon-document"></i> 总结内容</span>
      </div>
      <div v-if="summary.content" class="markdown-content" v-html="renderMarkdown(summary.content)"></div>
      <el-empty v-else description="暂无内容"></el-empty>
      </el-card>
    </BaseCard>
  </div>
</template>

<script>
import { getSummaryDetail } from '../api/summary'
import BaseCard from '@/components/BaseCard'
import WelcomeBanner from '@/components/WelcomeBanner'

export default {
  name: 'SummaryDetail',
  components: { BaseCard, WelcomeBanner },
  data() {
    return {
      summaryId: null,
      summary: {
        content: '',
        create_time: '',
        robot_id: '',
        robot_name: '',
        summary_date: '',
        summary_id: '',
        summary_type: '',
        summary_type_name: '',
        title: '',
        update_time: ''
      },
      loading: false,
      // 类型配置
      typeConfig: {
        'D': { text: '日报', tagType: 'primary' },
        'W': { text: '周报', tagType: 'success' },
        'M': { text: '月报', tagType: 'warning' }
      }
    }
  },
  created() {
    this.summaryId = this.$route.params.id
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const data = await getSummaryDetail(this.summaryId)
        if (data) {
          this.summary = data
        } else {
          this.$message.error('获取数据失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    // 返回列表
    goBack() {
      this.$router.push({ name: 'SummaryList' })
    },
    // 获取类型标签类型
    getTypeTagType(type) {
      return this.typeConfig[type]?.tagType || 'info'
    },
    // 获取类型名称
    getTypeName(type) {
      return this.typeConfig[type]?.text || '未知'
    },
    // 获取机器人名称首字母
    getRobotInitial(name) {
      if (!name) return '?'
      return name.charAt(0).toUpperCase()
    },
    // 获取头像颜色
    getAvatarColor(name) {
      if (!name) return '#909399'
      const colors = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#8E44AD']
      let hash = 0
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash)
      }
      return colors[Math.abs(hash) % colors.length]
    },
    renderMarkdown(html) {
      return html || ''
    },
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-detail {
  padding: 16px;
  min-height: calc(100vh - 100px);
  background: linear-gradient(180deg, #f5f7fa 0%, #fff 100%);
}

/* 页面头部 - 统一为 Dashboard welcome-banner 风格 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: linear-gradient(135deg, #818cf8 0%, #a78bfa 100%);
  border-radius: 10px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(129, 140, 248, 0.22);

  .header-left,
  .header-right { display:flex; align-items:center; gap:10px; }

  .page-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    display:flex;
    align-items:center;
    gap:8px;
  }

  .header-left .el-button {
    background: rgba(255,255,255,0.12);
    color: #fff;
    border: none;
    height: 36px;
  }

  .header-right ::v-deep .el-tag {
    background: rgba(255,255,255,0.12) !important;
    color: #fff !important;
  }
}

/* 卡片样式：白色卡片 + 阴影 + 柔和圆角 */
.info-card,
.content-card {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  overflow: hidden;
}

.card-header {
  font-weight: 600;
  font-size: 15px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  border-bottom: 1px solid #f0f2f5;
  background: linear-gradient(180deg, rgba(245,247,250,0.6), rgba(255,255,255,0.4));
}

/* 信息网格 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  padding: 16px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #fafbfc;
  border-radius: 8px;

  .info-label {
    color: #909399;
    font-weight: 600;
    min-width: 100px;
  }

  .info-value {
    color: #333;
    font-weight: 600;
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

/* Markdown内容 */
.content-card .markdown-content {
  padding: 18px;
  line-height: 1.8;
  color: #333;
  font-size: 14px;
  background: #fff;
}

.content-card ::v-deep h1,
.content-card ::v-deep h2,
.content-card ::v-deep h3,
.content-card ::v-deep h4 {
  color: #333;
  margin-top: 20px;
  margin-bottom: 12px;
}

.content-card ::v-deep p { margin-bottom: 14px; }
.content-card ::v-deep ul, .content-card ::v-deep ol { margin-bottom: 14px; padding-left: 24px; }
.content-card ::v-deep code { background: #f5f7fa; padding: 2px 6px; border-radius: 4px; }
.content-card ::v-deep pre { background: #f5f7fa; padding: 12px; border-radius: 6px; overflow-x:auto; }

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .page-header { flex-direction: column; gap:12px; text-align:center; }
  .info-grid { grid-template-columns: 1fr; padding: 12px; }
  .info-item { flex-direction: column; align-items:flex-start; }
  .content-card .markdown-content { padding: 12px; }
}
</style>
